import React, { useEffect, useState } from 'react';
import '../assets/css/custom.css';
import '../assets/css/client.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import bike from '../assets/img/bike.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import clientlogo from '../assets/img/user1.jpg';
import NoBuilding from "../assets/img/no-category-icon.png";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Menus from "./menus";
import stopMark from "../assets/img/stop.png";
import TowerIcon from "../assets/img/category-tile-icon.png";
import { commonAPI } from "../services/CommonAPIService"
import { ErrorSource } from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AccessControlType() {
    const [CategoryList, setCategoryList] = useState([]);
    const [CategoryId, setCategoryId] = useState("");
    const [BuildingId, setBuildingId] = useState("");
    const [CategoryName, setCategoryName] = useState("");
    const [ETA, setETA] = useState(null);
    const [Loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddCategoryBtn, setAddCategoryBtn] = useState(false);
    const [UpdateCategoryBtn, setUpdateCategoryBtn] = useState(false);
    const [DeleteShow, setDeleteShow] = useState(false);
    const [SelectedCategoryId, setSelectedCategoryId] = useState("")
    const [BuildingList, setBuildingList] = useState([]);
    console.log("BuildingId", BuildingId)

    const setInputValue = (item) => {
        setShow(true)
        console.log("item", item)
        setAddCategoryBtn(false)
        setUpdateCategoryBtn(true)
        setCategoryName(item?.categoryName)
        setCategoryId(item?.categoryId)
        setETA(item?.eta)
    };

    const openCreateModal = () => {
        setShow(true)
        setAddCategoryBtn(true)
        setUpdateCategoryBtn(false)
        setCategoryName("")
        setETA(null)
    };

    const GetBuildingList = async () => {
        const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }

        try {
            setLoading(true);
            let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
            if (response.success===true){
                setBuildingList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = JSON.stringify({ 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Common/Building",
                "errorNumber": "GB01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "tower.js",
                "functionName": "GetBuildingList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    } 

    useEffect(() => {
        if(BuildingId){
            (async function(){
                await localStorage.setItem("BuildingId", BuildingId?.toString());
            })()

        GetAccesControlList();
            
        }else if (BuildingId == ""){
            setCategoryList([]);
        }
    }, [BuildingId])

    useEffect(() => {        
        (async function(){
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON?.parse(BuildingAuth);
            setBuildingId(myBuildingId);
        })()
    }, [])

    useEffect(() => {
        GetBuildingList();
    }, [])

    const GetAccesControlList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        setLoading(true);
        try {

            const endPointVariableKey = {
                buildingId: BuildingId
            }

            let response = await commonAPI("AccessControlType", undefined, endPointVariableKey);
            if (response?.success === true) {
                console.log("Table ComplaintCategory", response)
                setCategoryList(response?.data);
                setLoading(false);
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "ComplaintCategory",
                "errorNumber": "CL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Category.js",
                "functionName": "GetCategoryList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }
    useEffect(() => {
        if(BuildingId){
        GetAccesControlList();
        }
    }, [BuildingId])



    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setSelectedCategoryId(item)
        console.log(item)

    }

    const DeleteAccessControl = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "accessTypeId": SelectedCategoryId?.accessTypeId,
            "modifiedUserId": JSON.stringify(UserData?.userId),
        };
        console.log(bodydata,"bodyy")
        try {
            setLoading(true);
            const endPointVariableKey = {
                buildingId: BuildingId,
                accessTypeId: SelectedCategoryId?.accessTypeId,
            }

            let response = await commonAPI("AccessControlTypeDelete", bodydata, endPointVariableKey);

            if (response?.success == true && response?.message?.length == 0) {
                toast.success("Access control Type Deleted");
                setLoading(false);
                GetAccesControlList()
                setDeleteShow(false);
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "ComplaintCategoryDelete",
                "errorNumber": "CD01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Category.js",
                "functionName": "DeleteCategory",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }



    const addNewAccessControl = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            accessType: CategoryName,
            createdUserId: JSON.stringify(myUserData?.userId),
        }
        try {
            setLoading(true);

            if (!CategoryName) {
                toast.warning("Please enter Category Name");
                setLoading(false)
            } else {
                const endPointVariableKey = {
                    buildingId: BuildingId
                }
                let response = await commonAPI("AccessControlTypeAdd", bodydata, endPointVariableKey);
                if (response?.success == true && response?.message?.length == 0) {
                    toast.success("Access Type Added");
                    // console.log(response.success);
                    GetAccesControlList()
                    setShow(false)
                    setLoading(false);
                } else {
                    toast.error(response?.message[0]);
                    setLoading(false);
                }
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "ComplaintCategoryAdd",
                "errorNumber": "AC01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Category.js",
                "functionName": "addNewCategory",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


   







    const [show, setShow] = useState(false);

    return (
        <>
            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            {/* <Menus/> */}

            <ToastContainer />
            <div className="row mb-3 mt-5 pt-5" style={{ alignItem: 'center' }}>
                <div className="col-lg-6 col-md-6">
                    <div className="HeadingTop">
                        <h3> Access Control </h3>
                        <span> Define, regulate, and customize different levels of access permissions.</span>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 mb-3 mb-md-0  text-right" style={{ alignContent: 'center' }}>
                    <select size="md" className="sltareamodal col-4 ml-auto" value={BuildingId} onChange={(e) => {
                    console.log("selection", e.target.value)
                    setBuildingId(e.target.value);}}>
                    <option value="">Select Building</option>
                    {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}>{item?.buildingName}</option>): null}
                </select>
                    <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New </Button>{' '}
                </div>
            </div>








            <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Header closeButton className='headerMDL'>
                    <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
                        {UpdateCategoryBtn ? <>Update Access Control</> : <>Add Access Control</>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="helpingElelemnt_uuy002">


                    <div className="row" id="validation">
                        <div className="col-12">

                            <div className="card-body p-0">

                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">

                                    <div className="content clearfix">


                                        <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                            <div className="row text-left">
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label for="wfirstName2"> Access Control Name  <span className="danger">*</span> </label>
                                                        <input type="text" value={CategoryName} onChange={(e) => { setCategoryName(e.target.value) }} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> </div>
                                                </div>


                                            </div>
                                        </section>

                                    </div>


                                </form>
                            </div>

                        </div>
                    </div>

                </Modal.Body>

                <div className="fixed_allbtn">
                    <div className="upload_btn">
                        <ul role="menu" aria-label="Pagination" className='mb-0'>
                            {AddCategoryBtn ?
                                // <li aria-hidden="false" aria-disabled="false">
                                //     <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                //     <a className='btn btn-contained' onClick={addNewTower} role="menuitem">Submit </a>
                                // </li>
                                <div className="  align-self-start">
                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                    <button type="button" className="btn btn-info" onClick={() => addNewAccessControl()}> Submit</button>
                                </div>
                                : null}
                            {UpdateCategoryBtn ?
                                <div className="  align-self-start">
                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                    <button type="button" className="btn btn-info"> Update</button>
                                </div>
                                // <li aria-hidden="true">
                                //     <a href="#finish" onClick={UpdateTower} role="menuitem">Update</a>
                                // </li>
                                : null}
                        </ul>
                    </div>
                </div>



            </Modal>





            <div className="row">
                <div className="col-12">


                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">
                        <div className="row">

                            {!CategoryList?.length && CategoryList?.length != null ?
                                <div className='bg-white' style={{ paddingBottom: "50px", borderRadius: "10px" }}>
                                    <div className='col-12 text-center'>
                                        <img src={NoBuilding} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
                                    </div>
                                    <br />
                                    <h3 className='col-12 text-center  NoDataShowTextColor' style={{ marginTop: "0px" }}> No Access Control Type found</h3>
                                    <h5 className='col-12 text-center  NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a Access Control Type</h5>
                                </div> : null}
                            {CategoryList
                                ? CategoryList?.map((item, index) => (
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                                        <div className="clientTiles" style={{ height: 115 }}>
                                            <div className="ClientImg">
                                                <div className="tabs_img">
                                                    <img src={TowerIcon} class="img img-responsive" alt="client-img" />
                                                </div>
                                                <div class="bars_font">
                                                    {/* <h3 className="font_trigger" onClick={() => { setInputValue(item); }} >
                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                    </h3> */}
                                                    <h3 className="font_trigger" onClick={() => { ShowDeleteModal(item); }}>
                                                        <FontAwesomeIcon icon={faTrashCan} />
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="ClientText">
                                                <div className="l-two">
                                                    <h1> {item?.accessType} </h1>
                                                    {/* <h4>{item?.buildingName} </h4> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>


                </div>
            </div>

            <Modal centered show={DeleteShow} onHide={() =>
                setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                <div className="FnFtxt">
                                    <h2> Delete Access Control Type  </h2>
                                    <h3> Are you sure you want to delete? </h3>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                        <div className='both_ConfrmBTN col-6' onClick={DeleteAccessControl}>
                            <Button variant="danger">Delete</Button>{' '}
                        </div>
                        <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                            <Button variant="light"> Cancel</Button>{' '}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>)

}
export default AccessControlType